<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="goBack"
        >列表</a-breadcrumb-item
      >
      <a-breadcrumb-item>文章详情</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="header">
      <h3>{{ article.articleTitle || "" }}</h3>
      <p class="article-info">
        <!-- <span>作者：{{ article.articleAuthor || "" }}</span>
        <span> 审核：{{ article.articleExamine || "" }}</span>
        <span>编辑：{{ article.articleEdit || "" }}</span>
        <span>来源：{{ article.articleSource || "" }}</span> -->
        <span class="time">{{ article.createTime || "" }}</span>
      </p>
    </div>
    <div class="artilce">
      <div class="ql-editor" v-html="article.articleContent"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getArticleDetail } from "@/api/article";
export default {
  components: {},
  data() {
    return {
      article: {},
    };
  },
  computed: {
    ...mapGetters({
      layoutTitle: "layout/lyaoutTitle",
    }),
  },
  watch: {
    "$route.query": {
      handler(val) {
        this.getDetail();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations({
      setLayoutTitle: "layout/setLayoutTitle",
    }),
    onSearch() {},
    toHome() {
      this.$router.push("/");
    },
    goBack() {
      const { fromPage, typeId } = this.$route.query
      this.$router.replace({
        path: '/articleList',
        query: {
          typeId,
          page: fromPage || 1
        }
      })
    },
    async getDetail() {
      const params = {
        id: this.$route.query.articleId,
      };
      const { data, code } = await getArticleDetail(params);
      if (code == 200) {
        this.article = data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fontColor1 {
  color: #fe695c;
  font-size: 14px;
}
.fontColor {
  color: #8e8e8e;
  font-size: 14px;
}
.fontstyle {
  font-size: 14px;
  cursor: pointer;
}
.center {
  margin-top: 52px;
  text-align: center;
  .inform {
    margin: 12px 0;
  }
}
.flex {
  display: flex;
  justify-content: space-evenly;
}
.container {
  .header {
    margin-top: 20px;
    text-align: center;
    h3 {
      font-size: 22px;
      font-weight: 600;
    }
    .article-info {
      span {
        padding: 0 10px;
        font-size: 14px;
      }
      .time {
        padding-left: 34px;
      }
    }
    .article {
      width: 980px;
    }
  }
}
/deep/img {
  width: 100%;
  // display: block;
  // margin: auto;
  // // width: 50%;
  // width: 776px;
  // object-fit: cover;
  // image-rendering: -moz-crisp-edges;
  // image-rendering: -o-crisp-edges;
  // image-rendering: -webkit-optimize-contrast;
  // image-rendering: crisp-edges;
  // -ms-interpolation-mode: nearest-neighbor;
}
</style>
